import * as React from 'react';
import type {BookingInfoProps} from './booking-info.type';
import {useRootMachine} from '../../hooks/useRootMachine';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {selectRescheduleLimit} from '../../selectors/commonSelector';
import {RootMachineContext} from '../../machines/rootMachine/rootMachine.context';

import {
  BodySmall,
  BodySmallBold,
  SubTitleMedium,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {SemanticIcon} from '@spaced-out/ui-design-system/lib/components/Icon/SemanticIcon';
import {useIsMobile} from 'src/components/scheduler/booking-v2/hooks/useIsMobile';

import css from './booking-info.css';
import {InContextAlert} from '@spaced-out/ui-design-system/lib/components/InContextAlert';


export const BookingInfo = ({
  title,
  brandLogo,
  bookingInfoItems,
}: BookingInfoProps) => {
  const isMobileView = useIsMobile();
  const {t} = useLabelTranslation();
  const {rootState} = useRootMachine();
  const rescheduleLimit = RootMachineContext.useSelector(selectRescheduleLimit);
  const isReschedule = rootState.matches('rescheduleFlow');

  const showRescheduleLimit = rescheduleLimit > -1 && isReschedule;

  return (
    <div className={css.bookingInfoContainer}>
      <div className={css.bookingInfoHeader}>
        {!isMobileView && brandLogo && (
          <img
            src={brandLogo}
            // eslint-disable-next-line @spaced-out/i18n/no-static-labels
            alt="agency logo"
            className={css.logoPreview}
          />
        )}
        {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
        <SubTitleMedium color="primary">{title || ''}</SubTitleMedium>
      </div>
      <div className={css.bookingInfoItems}>
        {bookingInfoItems.map((item, index: number) => (
          <div key={item.label + index} className={css.bookingInfoItem}>
            <SemanticIcon
              size="small"
              type="solid"
              semantic="neutral"
              name={item.icon}
            />
            <div className={css.bookingInfoItemText}>
              {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
              <BodySmallBold>{item.label}</BodySmallBold>
              {item.subLabel ? (
                // eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels
                <BodySmall color="secondary">{item.subLabel}</BodySmall>
              ) : null}
            </div>
          </div>
        ))}
      </div>
      {showRescheduleLimit && (
        <InContextAlert semantic="information">
          {`${t('You_have_rescheduleLimit_reschedules_left', {
            rescheduleLimit,
          })}.`}
        </InContextAlert>
      )}
    </div>
  );
};
